module.exports = __webpack_public_path__ + "static/aopzebrabath1-c356167f0cf791ffbf789eb10972c4ca.jpeg";